import React, { Component } from "react";
import { Field, reduxForm } from "redux-form";

import TextField from "../../../../components/FormElements/TextField";

import { minLength8, required } from "../../../../util/formValidations";

import RoundedButton from "../../../../components/RoundedButton";
import OverlayLoader from "../../../../components/OverlayLoader";
import { FormHelperText } from "material-ui/Form";

class ResetPasswordForm extends Component {
  render() {
    const { handleSubmit, submitting, error } = this.props;
    return (
      <form className="form" onSubmit={handleSubmit}>
        {submitting && <OverlayLoader />}
        <h1>Reset Password</h1>
        <span>Please type Your new password</span>
        <Field
          name="password"
          component={TextField}
          label="Password"
          validate={[required, minLength8]}
          type="password"
        />
        <div>
          <RoundedButton value="Submit" className="-primary" type="submit" />
        </div>
        <FormHelperText error>{error}</FormHelperText>
      </form>
    );
  }
}

export default reduxForm({ form: "resetPasswordForm" })(ResetPasswordForm);



// WEBPACK FOOTER //
// ./src/scenes/ResetPasswordPage/components/ResetPasswordForm/index.js